// 本地日期（每日挑战按本地日期 YYYY-MM-DD 出题与记连续天数）。测试钩子可以注入一个固定日期。

let override: string | null = null;

/** 测试用：固定"今天"（'YYYY-MM-DD'）；null = 恢复真实本地时间 */
export function setToday(date: string | null): void {
  if (date !== null && !/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error(`bad date ${date}`);
  override = date;
}

export function today(): string {
  if (override) return override;
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
